module.exports = __webpack_public_path__ + "static/img/txt-5.ada6d02.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/zbqfBrand/txt-5.png
// module id = HQ+N
// module chunks = 0